module.exports = __webpack_public_path__ + "img/bg-first-financial-intro.7d463608.jpg";